module.exports = __webpack_public_path__ + "static/img/Dubai-Fatima-El-Habachi.8e77cc9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-people/Dubai-Fatima-El-Habachi.jpg
// module id = MY8I
// module chunks = 0